import i18n from 'i18nextInstance';

const parseStatus = status => {
    switch (status) {

    case 'Accepted':
        return i18n.t('En Llamada');

    case 'Available':
        return i18n.t('Disponible');

    case 'Busy':
        return i18n.t('En Sesión');

    case 'Finalized':
        return i18n.t('Atendido');

    case 'Pending':
    case 'Alert':
        return i18n.t('En Espera');

    case 'Unavailable':
        return i18n.t('No Disponible');

    case 'Waiting':
        return i18n.t('Esperando llamada');

    default:
        return '';
        
    }
};

export default parseStatus;
